import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect, forwardRef} from 'react';
import {connect} from 'react-redux';

const NewNumberDataError = forwardRef((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => {
      setIsVisible(true);
    });
  }, []);

  return (
    <div ref={ref} tabIndex={-1} className={`new-number-data-error-container smooth-fade-in ${isVisible ? 'visible' : ''}`}>
      <div className='new-number-data-error'>
        <div className='border'></div>
        <Image src={require('../../Icons/warning.svg')} alt='v-icon' />
        <div className='m-title'>
          משהו לא עבד, <br />
          אפשר לנסות לרענן את העמוד
        </div>
      </div>
    </div>
  );
});

NewNumberDataError.displayName = 'NewNumberDataError';

const mapStateToProps = (state) => ({
  changePhoneNumber: state.changePhoneNumber,
});

export default connect(mapStateToProps, null, null, {forwardRef: true})(NewNumberDataError);
